var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../Components/ComponentButton';
import { addToBasket } from '../Purchase/API';
import T from '../../Utils/Locale';
const PurchaseButton = ({ productType, purchaseType, legalDocument = null }) => {
    const [isLoading, toggleLoading] = useState(false);
    const upgradeDocument = legalDocument && legalDocument.isPurchased ? legalDocument.id : false;
    const handler = () => __awaiter(void 0, void 0, void 0, function* () {
        toggleLoading(true);
        if (upgradeDocument) {
            window.location.replace(`/my-documents/upgrade/${upgradeDocument}?purchaseType=${purchaseType}`);
        }
        else {
            const identifier = legalDocument ? legalDocument.id : null;
            yield addToBasket(productType, purchaseType, identifier);
            toggleLoading(false);
            document.querySelector('#toggle-basket').click();
        }
    });
    return (_jsx(Button, { classes: 'btn border-solid ml-auto md:ml-auto xs:text-sm text-lg tailwind-reset bg-white border border-dark-teal text-dark-teal xs:px-8 px-10 hover:text-white active:shadow-outline', onClick: () => handler(), isLoading: isLoading, title: !upgradeDocument ? T('dashboard.purchase') : T('dashboard.upgrade') }));
};
PurchaseButton.propTypes = {
    productType: PropTypes.string.isRequired,
    purchaseType: PropTypes.string.isRequired,
    legalDocument: PropTypes.shape()
};
export default PurchaseButton;
